import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { usePageMeta } from '@/hooks/usePageMeta';
import { SEO } from '@/content/yawasCopy';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import MenuPreviewSection from './components/MenuPreviewSection';
import AboutSection from './components/AboutSection';
import GallerySection from './components/GallerySection';
import TestimonialsSection from './components/TestimonialsSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  usePageMeta(SEO.home);

  return (
    <div className="min-h-screen">
      <Navbar transparent />
      <HeroSection />
      <FeaturesSection />
      <MenuPreviewSection />
      <AboutSection />
      <GallerySection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
